import _toConsumableArray from"@babel/runtime/helpers/esm/toConsumableArray";import"core-js/modules/es.array.concat.js";var AuthTokenQueryKeys={global:['authTokens'],/**
   * All
   */all:function all(){return[].concat(_toConsumableArray(AuthTokenQueryKeys.global),['all']);},/**
   * Current
   */current:function current(){return[].concat(_toConsumableArray(AuthTokenQueryKeys.global),['current']);}};export{AuthTokenQueryKeys};